import { memo } from 'react'
import cn from 'classnames'

import type { ProgressSegmentsProps } from './types'

import styles from './ProgressSegments.module.scss'

/** Прогресс многошагового флоу (спека 01 §8): height 4, radius 2, gap 5. */
export const ProgressSegments = memo(function ProgressSegments(props: ProgressSegmentsProps) {
  const { total, current } = props

  return (
    <div
      className={styles.root}
      role='progressbar'
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
    >
      {Array.from({ length: total }, (_, index) => (
        <span key={index} className={cn(styles.segment, index < current && styles.segment_DONE)} />
      ))}
    </div>
  )
})
